import { HttpRequestModel } from 'libs/services/src/models/endpoints/HttpRequest';
import { Injectable } from '@angular/core';
import {from, Observable} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {map, filter, switchMap} from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { DefectiveRegistryModel } from '../../../models/endpoints/DefectiveRegistry';
import { BehaviorSubject } from "rxjs";
import {AuthenticationService} from "@suite/services";
import {ExpeditionIncidenceModel} from "../../../models/endpoints/ExpeditionIncidence";
import {ExpeditionAddressesModel} from "../../../models/endpoints/Expeditions/Adresses";

@Injectable({
  providedIn: 'root'
})
export class ExpeditionManualService {

  private apiMga = environment.apiBase;
  private apiGeneralLogisticOperator = environment.apiLogisticOperator;
  private createExpeditionUrl = this.apiGeneralLogisticOperator + '/expedition/';
  private getWarehouseUrl = this.apiGeneralLogisticOperator + '/warehouse-logistic/index';
  private getWarehouseLogisticUrl = this.apiGeneralLogisticOperator + '/warehouse-logistic/';
  private getLogisticsOperatorsUrl = this.apiGeneralLogisticOperator + '/logistics-operators/';
  private getMarketsUrl = this.apiMga + '/markets/';
  private getCountriesUrl = this.apiMga + '/countries/';
  private getProvincesUrl = this.apiMga + '/provinces/';
  private getRulesUrl = this.apiGeneralLogisticOperator + '/logistics-operators-rules/';
  private postManageIncidenceUrl = this.apiMga + '/expeditions-manual/incidence/manage';
  private postOrderAddressUrl: string = this.apiMga + '/opl-expedition/external/order/address';
  private putUpdateExternalOrderAddressUrl: string = this.apiMga + '/opl-expedition/external/order/address/update';

  private baseUrl: string;
  private getTrasnports: string;
  private epxeditionManualStore: string;
  private getIncidences: string;
  private getFilter: string;
  private getIncidenceById: string;

  constructor(private http: HttpClient, private auth: AuthenticationService,) {
    this.baseUrl = environment.apiBase;
    this.getTrasnports = `${this.baseUrl}/expeditions-manual/get-transports`;
    this.epxeditionManualStore = `${this.baseUrl}/expeditions-manual/store`;
    this.getIncidences = `${this.baseUrl}/expeditions-manual/get-incidence`;
    this.getFilter = `${this.baseUrl}/expeditions-manual/get-incidence-filters`;
    this.getIncidenceById = `${this.baseUrl}/expeditions-manual/get-incidence-id`;
  }

  store(body): Observable<any>{
    return this.http.post<HttpRequestModel.Response>(this.epxeditionManualStore, body).pipe(
      map(resp => resp.data)
    )
  }

  postManageIncidence(body: ExpeditionIncidenceModel.ParamsManageIncidence, destinyId, destinyChanged): Observable<ExpeditionIncidenceModel.ResponseManageIncidence> {
    body.destinyId = destinyId;
    body.destinyChanged = destinyChanged;
    return this.http.post<HttpRequestModel.Response>(this.postManageIncidenceUrl, body).pipe(
      map(resp => resp.data)
    )
  }

  getTrasnport(): Observable<any>{
    return this.http.get<HttpRequestModel.Response>(this.getTrasnports).pipe(
      map(resp => resp.data)
    )
  }

  getIncidence(body): Observable<any>{
    return this.http.post<HttpRequestModel.Response>(this.getIncidences, body).pipe(
      map(resp => {
        return resp.data
      })
    )
  }

  getFilters(body){
    return this.http.post<HttpRequestModel.Response>(this.getFilter, body).pipe(
      map(resp => {
        return resp.data
      })
    )
  }

  getExpedition(id){
    return this.http.get<HttpRequestModel.Response>(this.getIncidenceById+'/'+id).pipe(
      map(resp => resp.data)
    )
  }

  createExpedition(data):Observable<any> {
    return from(this.auth.getCurrentToken()).pipe(switchMap(token=>{
      let headers:HttpHeaders = new HttpHeaders({Authorization:token});
      return this.http.post<any>(this.createExpeditionUrl, data, {headers}).pipe(map(response=>{
        return response.data;
      }));
    }));
  }

  getWarehouse():Observable<any> {
    return from(this.auth.getCurrentToken()).pipe(switchMap(token=>{
      let headers:HttpHeaders = new HttpHeaders({Authorization:token});
      return this.http.get<any>(this.getWarehouseUrl, {headers}).pipe(map(response=>{
        return response.data;
      }));
    }));
  }

  getLogisticsOperators():Observable<any> {
    return from(this.auth.getCurrentToken()).pipe(switchMap(token=>{
      let headers:HttpHeaders = new HttpHeaders({Authorization:token});
      return this.http.get<any>(this.getLogisticsOperatorsUrl, {headers}).pipe(map(response=>{
        return response.data;
      }));
    }));
  }

  getMarkets():Observable<any> {
    return from(this.auth.getCurrentToken()).pipe(switchMap(token=>{
      let headers:HttpHeaders = new HttpHeaders({Authorization:token});
      return this.http.get<any>(this.getMarketsUrl, {headers}).pipe(map(response=>{
        return response.data;
      }));
    }));
  }

  getCountries():Observable<any> {
    return from(this.auth.getCurrentToken()).pipe(switchMap(token=>{
      let headers:HttpHeaders = new HttpHeaders({Authorization:token});
      return this.http.get<any>(this.getCountriesUrl, {headers}).pipe(map(response=>{
        return response.data;
      }));
    }));
  }

  getProvinces():Observable<any> {
    return from(this.auth.getCurrentToken()).pipe(switchMap(token=>{
      let headers:HttpHeaders = new HttpHeaders({Authorization:token});
      return this.http.get<any>(this.getProvincesUrl, {headers}).pipe(map(response=>{
        return response.data;
      }));
    }));
  }

  getRules():Observable<any> {
    return from(this.auth.getCurrentToken()).pipe(switchMap(token=>{
      let headers:HttpHeaders = new HttpHeaders({Authorization:token});
      return this.http.get<any>(this.getRulesUrl, {headers}).pipe(map(response=>{
        return response.data;
      }));
    }));
  }

  public postOrderAddress(body: { externalOrderId: string }): Observable<ExpeditionAddressesModel.ResponseGetExternalOrderAddress> {
    return this.http.post<HttpRequestModel.Response>(this.postOrderAddressUrl, body).pipe(map(resp => resp.data));
  }

  public putUpdateExternalOrderAddress(body: ExpeditionAddressesModel.ParamsUpdateExternalOrderAddress): Observable<any> {
    return this.http.put<HttpRequestModel.Response>(this.putUpdateExternalOrderAddressUrl, body).pipe(map(resp => resp.data));
  }
}
